var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71429 17.7143C3.71429 19.1344 4.86555 20.2857 6.28571 20.2857L17.7143 20.2857C19.1344 20.2857 20.2857 19.1344 20.2857 17.7143L20.2857 16.5714C20.2857 16.098 20.6695 15.7143 21.1429 15.7143C21.6162 15.7143 22 16.098 22 16.5714L22 17.7143C22 20.0812 20.0812 22 17.7143 22L6.28571 22C3.91878 22 2 20.0812 2 17.7143L2 16.5714C2 16.098 2.38376 15.7143 2.85714 15.7143C3.33053 15.7143 3.71429 16.098 3.71429 16.5714L3.71429 17.7143ZM6.82248 11.3939C7.15721 11.0592 7.69993 11.0592 8.03466 11.3939L11.1429 14.5021L11.1429 2.85714C11.1429 2.38375 11.5266 2 12 2C12.4734 2 12.8571 2.38375 12.8571 2.85714L12.8571 14.5021L15.9653 11.3939C16.3001 11.0592 16.8428 11.0592 17.1775 11.3939C17.5123 11.7286 17.5123 12.2714 17.1775 12.6061L12.6061 17.1775C12.2714 17.5123 11.7286 17.5123 11.3939 17.1775L6.82248 12.6061C6.48774 12.2714 6.48774 11.7286 6.82248 11.3939Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon6);
export default __webpack_public_path__ + "static/media/download-icon-6.240e827023a02269ba545b70b500adbd.svg";
export { ForwardRef as ReactComponent };